<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :search="search"
    :items="provider_types"
    @dblclick:row="handleClickRow"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>TIPOS DE FORNECEDOR</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark to="/tipo-fornecedor/novo">
          <v-icon>mdi-plus</v-icon>
          NOVO
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.updated_at="{ item }">
      {{ item.updated_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="error">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red darken-1"
            @click="deleteItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Deletar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import * as API from "@/api/requests/ProviderTypeRequest";

export default {
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
        width: 50,
      },
      { text: "Nome", value: "name", width: 450 },
      { text: "Data Cadastro", value: "created_at", width: 200 },
      { text: "Última Atualização", value: "updated_at", width: 200 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    provider_types: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getProviderTypes();
    },

    async getProviderTypes() {
      this.loading = true;
      this.provider_types = [];
      try {
        let res = await API.getAll();
        this.provider_types = res;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({ name: "ProviderTypeEdit", params: { id: item.id } });
    },
    deleteItem(item) {
      this.editedIndex = this.provider_types.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      console.log(this.editedItem);
      this.loading = true;
      this.provider_types = [];
      try {
        let res = await API.destroy(this.editedItem.id);
        console.log(res);
        this.loading = false;
        this.initialize();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    handleClickRow(event, item) {
      this.editItem(item.item);
    },
  },
};
</script>
